import { useQuery } from '@tanstack/react-query';
import { IGetJobPostingsPayload } from '../types';
import { PermanentJobsService } from '../services';

export const useGetJobPostings = (payload?: IGetJobPostingsPayload) => {
  const { data, isFetching, isLoading } = useQuery({
    initialData: {
      data: [],
      pagination: { page: 1, pageSize: 10, total: 0, totalPages: 1 },
      statistics: { tabs: { active: 0, closed: 0, draft: 0, suspended: 0 } },
    },
    queryKey: ['GET_JOB_POSTINGS', { payload }],
    queryFn: async () =>
      PermanentJobsService.getJobPostings({
        limit: payload?.limit || 10,
        officeId: payload?.officeId,
        orderBy: payload?.orderBy,
        orderDirection: payload?.orderDirection,
        page: payload?.page || 1,
        professionType: payload?.professionType,
        status: payload?.status,
        subProfessionType: payload?.subProfessionType,
      }),
    retry: false,
  });

  return {
    ...data,
    isInitialLoading: isLoading,
    isLoading: isLoading || isFetching,
  };
};
